import types from '../types';
import { uri } from 'utils';

/**
 * @param {string} checkboxGroupValueInURL
 * @param {string} filterValue
 * @returns {boolean}
 */
const isChecked = (checkboxGroupValueInURL, filterValue) =>
    uri
        .decode(checkboxGroupValueInURL)
        .split(uri.VALUE_SEPARATOR)
        .includes(filterValue.toString());

/**
 * @param {types.CheckBoxOrRadioOption[]} defaultValues
 * @param {string} url
 * @param {string} checkboxGroupId
 * @returns {types.CheckBoxOrRadioOption[]}
 */
export default function getCheckboxGroupStateFromURL(
    defaultValues,
    url,
    checkboxGroupId
) {
    const checkboxGroupValueInURL = uri.getParams(url)[checkboxGroupId];

    // No params in URL, skip merging and use the defaults
    if (!checkboxGroupValueInURL) {
        return defaultValues;
    }

    return defaultValues.map(option => {
        if (
            option.subcategoriesContent &&
            option.subcategoriesContent.subcategories &&
            option.subcategoriesContent.subcategories.length
        ) {
            const { subcategories } = option.subcategoriesContent;

            const nextSubcategories = subcategories.map(item => {
                return {
                    ...item,
                    checked: isChecked(checkboxGroupValueInURL, item.value)
                };
            });

            return {
                ...option,
                checked: isChecked(checkboxGroupValueInURL, option.value),
                subcategoriesContent: {
                    ...option.subcategoriesContent,
                    subcategories: nextSubcategories
                }
            };
        }

        return {
            ...option,
            checked: isChecked(checkboxGroupValueInURL, option.value)
        };
    });
}
